import { DeleteDialog } from "components";
import GeneralOptionsPanel from "components/optionspanel/GeneralOptionsPanel";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  optionsPanelData: server.dto.OptionsPanelDataV2
  listUrl: string
  productGroup: server.dto.ProductGroup
}

const ProductGroupOptionsPanel = (props: Props) => {
  const { optionsPanelData } = props;
  const [isDeleting, setIsDeleting] = React.useState(false);

  const onDelete = async () => {
    await window.CoreApi.ProductGroup.Delete({ productGroupId: props.productGroup.productGroupId });
    window.location.href = props.listUrl;
  }

  return <>
    <DeleteDialog
      spinForever
      isOpen={isDeleting}
      onDelete={onDelete}
      handleClose={() => { setIsDeleting(false); }}
      message={RESX.GeneralWarnings.DeleteSure}
    />
    <GeneralOptionsPanel data={optionsPanelData} links={[{
      text: RESX.Buttons.ListView,
      href: routes.productGroup_List().absolute,
      visible: true
    }, {
      text: RESX.Buttons.btnDelete,
      onClick: () => { setIsDeleting(true) },
      visible: true
    }]} />
  </>;
};

export default ProductGroupOptionsPanel;